import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import type { Language } from '../i18n/translations';

export default function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    const newLang: Language = language === 'nl' ? 'en' : 'nl';
    setLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-white/90 hover:text-white transition-colors rounded-lg hover:bg-green-700"
      aria-label="Switch language"
      title={`Switch to ${language === 'nl' ? 'English' : 'Dutch'}`}
    >
      <Globe className="w-4 h-4" />
      <span className="uppercase font-semibold">{language}</span>
    </button>
  );
}
